export default "__VITE_ASSET__NUbLRN5B__"